<template lang="pug">
div
  div.title-btn
    .md-headline Series
    md-button#btnClean.md-icon-button(@click='unselectedSerie')
      md-icon(md-iconset='fa fa-eraser') 
  // Serie
  serie-selector(v-model='entity.serie', @onSerieSelectorChange='onSerieSelectorChange')
  // Season Number
  md-input-container(:class='{ "md-input-invalid" : formSubmitted && seasonNumberError }', v-if='!isMiniSerie')
    label Season Number
    md-input(v-model='entity.seasonNumber', @change='onSeasonSelect', type="number", min=0, max=100, ref="seasonNumber", :disabled='entity.serie === null || isMiniSerie')
    span.md-error(v-if='formSubmitted && seasonNumberError') This field is required
  // Episode Number
  md-input-container(:class='{ "md-input-invalid" : formSubmitted && episodeNumberError }')
    label Episode Number
    md-input(v-model='entity.episodeNumber', @change='onEpisodeSelect',  type="number", min=0, max=100, :disabled='entity.serie === null')
    span.md-error(v-if='formSubmitted && !isNaN(entity.episodeNumber)') This field is required
  span.md-error(v-if='episodeFieldError') Episode number was already taken
</template>

<script>
import SerieSelector from '../../shared-components/serie/SerieSelector'

export default {
  components: {
    SerieSelector
  },
  props: {
    entity: {
      type: Object,
      required: true
    },
    formSubmitted: {
      type: Boolean,
      required: true
    },
    episodeNumberError: {
      type: Boolean,
      required: true
    },
    seasonNumberError: {
      type: Boolean,
      required: true
    },
  },
  data() {
    return {
      episodeFieldError: false,
      episodesFromSeason: [],
      seasonAndEpisodes:{
        0: [],
      },
      isMiniSerie: false,
      selectedSeason: null,
    }
  },
  methods: {
    cleanSeasonAndEpisodesNumbers(){
      this.entity.seasonNumber = null;
      this.selectedSeason = null;
      this.entity.episodeNumber = null;
    },

    unselectedSerie(){
      this.cleanSeasonAndEpisodesNumbers();
      this.entity.serie = null;
    },
    onSerieSelectorChange(value){
      this.isMiniSerie = value.isMiniSerie;
      this.$emit('isMiniSerie', this.isMiniSerie);
      if(value.serieId !== this.entity.serie) this.cleanSeasonAndEpisodesNumbers();
      this.entity.serie = value.serieId;
    },
    onSeasonSelect(value){
      this.selectedSeason = value;
      // Retrieve episode list (empty array if no season found)
      const episodes = this.seasonAndEpisodes[value];
      this.episodesFromSeason = episodes ? episodes : [];
      // Reset episode number (for control purposes)
      this.entity.episodeNumber = null;
    },
    onEpisodeSelect(value) {
      if (this.episodesFromSeason.includes(parseInt(value))) {
        // If found the episode number, show error
        this.episodeFieldError = true;
        // Due to async, a timeout it's needed
        setTimeout(() => {
          this.entity.episodeNumber = null;
        }, 500);
      } else {
        this.episodeFieldError = false;
      }
    },
  }
};
</script>

<style lang="scss" scoped>
  .form-controls {
    width: 100%;
  }
  .title-btn{
    display: flex;
    justify-content: space-between;
  }
  #btnClean:hover{
    background-color: rgb(234,67,53) !important;
    transform: scale(1.1);
  }
</style>



// WEBPACK FOOTER //
// src/shared-components/forms/ContentSerieForm.vue